import { render } from "./register.vue?vue&type=template&id=bb70ef44&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"

import "./register.vue?vue&type=style&index=0&id=bb70ef44&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb70ef44"]])

export default __exports__